import React from 'react';

import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Tooltip from '@mui/material/Tooltip';

function capitalizeWords(str) {
    if (!str) return '';
    return str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

const CLCard = ({ companyLogo, companyName, compensation, stability, growth, WLB, toxicity, approach, handleProfileOpen, handleProfileClose, parameterKeys = [] }) => {
    return (
        <div
            className="flex flex-col w-full p-5 border-2 rounded-lg cursor-pointer hover:border-orange-300 hover:bg-[#FCA54914]"
            onClick={handleProfileOpen}
        >
            {/* Header */}
            <div className='w-full flex flex-col sm:flex-row justify-between gap-4'>
                <div className="flex items-start gap-3 flex-1 min-w-0">
                    <img
                        src={companyLogo}
                        alt="Company logo"
                        className="rounded-md shrink-0 w-[50px] h-[50px]"
                    />
                    <div className="flex flex-col flex-1 gap-1 min-w-0">
                        <p className="font-dmsans font-bold text-[#404D61] text-left break-words">
                            {companyName}
                        </p>
                        <div className="flex flex-wrap items-center gap-1.5 text-sm">
                            {/* <p className="font-dmsans font-normal text-[#757D8A]">San Francisco, CA</p>
                            <Star className="w-4 h-4 text-yellow-400" fill="currentColor" stroke="currentColor" />
                            <p className="font-dmsans font-normal">4.9</p> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Tags Grid - Now full width */}
            <div className="w-full mt-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full">
                    {[
                        { label: 'Compensation', value: compensation, icon: '💰' },
                        { label: 'Stability', value: stability, icon: '📈' },
                        { label: 'Growth', value: growth, icon: '🚀' },
                        { label: 'Work Life Balance', value: WLB, icon: '💼' },
                        { label: 'Toxicity', value: toxicity, icon: '☠️' },
                        { label: 'Referral Possibility', value: approach, icon: '🤝' },
                    ].map(({ label, value, icon }) => {
                        const keysForThisLabel = parameterKeys[label] || [];
                        return (
                            <div
                                key={label}
                                className="flex w-full items-center gap-2 border rounded-md p-2 bg-[#f8f8f8] shadow-sm"
                            >
                                <div className="text-sm">{icon}</div>
                                <div className="leading-tight flex flex-col w-full">
                                    <div className="flex flex-row justify-between items-center group relative">
                                        <p className="text-xs text-gray-600 font-dmsans font-normal">{label}</p>
                                        <Tooltip
                                            title={
                                                <p className='text-md text-left'>
                                                    We are analyzing parameters such as <strong>{capitalizeWords(keysForThisLabel.join(', '))}</strong> from multiple sources across the web to get you a <strong className='text'>{label}</strong> score for <strong>{companyName}</strong>.
                                                </p>
                                            }
                                            placement="top"
                                            arrow
                                        >
                                            <InfoOutlineIcon
                                                className="cursor-pointer"
                                                style={{ width: 15, height: 15 }}
                                            />
                                        </Tooltip>
                                    </div>
                                    <p
                                        className="text-sm font-dmsans font-semibold text-left"
                                        style={{
                                            color:
                                                label === 'Toxicity'
                                                    ? value > 50
                                                        ? 'red'
                                                        : 'green'
                                                    : value < 50
                                                        ? 'red'
                                                        : 'green',
                                        }}
                                    >
                                        {value}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CLCard;